import { KeyValue } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { isPresent } from '@mtna/core-ts';

/**
 * Filters properties from a keyvalue pipe with existing values.
 * @param items The array of objects transformed through the KeyValuePipe
 * @param whitelist A map of properties acceptable to return, in order to filter unwanted properties
 * @returns list of keyvalue pairs, sorted on the keys from original template order
 */
@Pipe({
  name: 'filterEmpty',
})
export class FilterEmptyPipe implements PipeTransform {
  transform<T extends KeyValue<string, unknown>>(items: T[], whitelist: { [id: string]: unknown }): T[] {
    return (items || [])
      .filter((item) => {
        if (isPresent(item.value) && !!whitelist[item.key]) {
          if (typeof item.value === 'string' && !item.value.length) {
            return false;
          }
          return true;
        }
        return false;
      })
      .sort((a: T, b: T) => (_order[a.key] > _order[b.key] ? 1 : -1));
  }
}

// Ordered as originally hardcoded in html
const _order: { [key: string]: number } = {
  label: 0,
  description: 1,
  documentation: 2,
  questionText: 3,
  universe: 4,
  exclusion: 5,
  note: 6,
  validValues: 7,
  dataType: 8,
  format: 9,
  fixedStorageWidth: 10,
  startPosition: 11,
  endPosition: 12,
  decimals: 13,
};
